import React, { ComponentProps } from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { asView } from '../../../_lib/ViewFetcher';
import { ISonURL } from '../../../types/IUrl';
import { ContentParagraph } from '../../../_lib/components/ContentParagraph';
import { Dfn } from '../../../_lib/components/Dfn/Dfn';

type ExternalContentEditDefaultProps = {
  iframe: ISonURL & { popUpUrl?: string };
};

function ExternalContentEditDefault({ iframe }: ExternalContentEditDefaultProps) {
  const { t } = useSonTranslation('ExternalContent');

  if (!iframe) {
    return null;
  }
  return (
    <div className="external-content">
      <ContentParagraph>
        <Dfn modifier="bold">{t('externalContentUrl')}</Dfn>: {iframe.url}
      </ContentParagraph>
      {iframe?.popUpUrl && (
        <ContentParagraph>
          <Dfn modifier="bold">{t('externalContentPopUpUrl')}</Dfn>: {iframe.popUpUrl}
        </ContentParagraph>
      )}
    </div>
  );
}

export const ExternalContentEditDefaultView = asView(ExternalContentEditDefault);
export type ExternalContentEditDefaultView = ComponentProps<typeof ExternalContentEditDefaultView>;
